<template>
  <div>
    <el-card shadow="never"
             class="aui-card--fill">
      <el-form :model="dataForm"
               ref="dataForm">
        <el-col :span="6">
          <el-form-item label="车辆底盘号"
                        prop="chassisNo">
            <label>：&#12288;{{dataForm.chassisNo}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车型分类id"
                        prop="vehicleClassId">
            <label>：&#12288;{{dataForm.vehicleClassId}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="研发代码id"
                        prop="rdCodeId">
            <label>：&#12288;{{dataForm.rdCodeId}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="品牌id"
                        prop="brandId">
            <label>：&#12288;{{dataForm.brandId}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="组织编号"
                        prop="companyId">
            <label>：&#12288;{{dataForm.companyId}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="所属场地id"
                        prop="subordinateSiteId">
            <label>：&#12288;{{dataForm.subordinateSiteId}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="当前场地id"
                        prop="presentSiteId">
            <label>：&#12288;{{dataForm.presentSiteId}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="当前场地名称"
                        prop="presentSiteName">
            <label>：&#12288;{{dataForm.presentSiteName}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车辆分类"
                        prop="vehicleClassification">
            <label>：&#12288;{{dataForm.vehicleClassification}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="车辆状态"
                        prop="status">
            <label>：&#12288;{{dataForm.status}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="生产日期"
                        prop="productionDate">
            <label>：&#12288;{{dataForm.productionDate}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="开始时间"
                        prop="startTime">
            <label>：&#12288;{{dataForm.startTime}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="结束时间"
                        prop="endTime">
            <label>：&#12288;{{dataForm.endTime}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否计算利用率"
                        prop="ifCount">
            <label>：&#12288;{{dataForm.ifCount}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="发动机型号"
                        prop="engineModel">
            <label>：&#12288;{{dataForm.engineModel}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否上传车辆配置文件"
                        prop="isUpload">
            <label>：&#12288;{{dataForm.isUpload}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建人"
                        prop="creator">
            <label>：&#12288;{{dataForm.creator}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建时间"
                        prop="createdDate">
            <label>：&#12288;{{dataForm.createdDate}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="修改人"
                        prop="modifier">
            <label>：&#12288;{{dataForm.modifier}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="上次修改时间"
                        prop="lastUpdatedDate">
            <label>：&#12288;{{dataForm.lastUpdatedDate}}</label>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="版本号"
                        prop="version">
            <label>：&#12288;{{dataForm.version}}</label>
          </el-form-item>
        </el-col>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataForm: {
        vehicleId: 0,
        chassisNo: '',
        vehicleClassId: '',
        rdCodeId: '',
        brandId: '',
        companyId: '',
        subordinateSiteId: '',
        presentSiteId: '',
        presentSiteName: '',
        vehicleClassification: '',
        status: '',
        productionDate: '',
        startTime: '',
        endTime: '',
        ifCount: '',
        engineModel: '',
        isUpload: '',
        creator: '',
        createdDate: '',
        modifier: '',
        lastUpdatedDate: '',
        version: ''
      }
    }
  },
  activated () {
    this.$nextTick(() => {
      this.$refs['dataForm'].resetFields()
      if (this.$route.query.vehicleId !== undefined) {
        this.dataForm.userTrainingId = this.$route.query.vehicleId
        this.getInfo()
      }
    })
  },
  methods: {
    // 获取信息
    getInfo () {
      this.$request.get(`/res/vehicleinfo/info`, { id: this.dataForm.vehicleId }).then((data) => {
        this.dataForm.chassisNo = data.chassisNo
        this.dataForm.vehicleClassId = data.vehicleClassId
        this.dataForm.rdCodeId = data.rdCodeId
        this.dataForm.brandId = data.brandId
        this.dataForm.companyId = data.companyId
        this.dataForm.subordinateSiteId = data.subordinateSiteId
        this.dataForm.presentSiteId = data.presentSiteId
        this.dataForm.presentSiteName = data.presentSiteName
        this.dataForm.vehicleClassification = data.vehicleClassification
        this.dataForm.status = data.status
        this.dataForm.productionDate = data.productionDate
        this.dataForm.startTime = data.startTime
        this.dataForm.endTime = data.endTime
        this.dataForm.ifCount = data.ifCount
        this.dataForm.engineModel = data.engineModel
        this.dataForm.isUpload = data.isUpload
        this.dataForm.creator = data.creator
        this.dataForm.createdDate = data.createdDate
        this.dataForm.modifier = data.modifier
        this.dataForm.lastUpdatedDate = data.lastUpdatedDate
        this.dataForm.version = data.version
      })
    },
    backPage () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
</style>
